import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { otherDeductionsDetailInputList5 } from '../../../common/data';

import ItemTitleSection from '../../../components/ItemTitleSection';
import InputItemSection from './OtherInputItemSection';
import Radio from '../../../components/common/Radio';
import Typography from '../../../components/common/Typography';
import TextField from '../../../components/common/TextField';

// 세액공제
const Type5 = ({ handleAddButton }) => {
  const { t } = useTranslation('deductions/other');
  const { t: tCommon } = useTranslation('common');
  const inputList = otherDeductionsDetailInputList5(t);
  const { s11_5Data } = useSelector(state => state.otherDeductions);
  const [dataList, setDataList] = useState({});

  useEffect(() => {
    if (s11_5Data) {
      setDataList({
        ...s11_5Data,
        htm062: s11_5Data.htm062 == '1' ? '1' : '',
        htmTaxFlag: s11_5Data.htmTaxFlag == '1' ? '1' : '',
      });
    }
  }, [s11_5Data]);

  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      <ItemTitleSection
        title={t('detail.type5.title')}
        addButton={true}
        handleAddButton={handleAddButton}
      />
      <InputItemSection
        dataList={dataList}
        inputList={inputList}
        addButton={true}
        disabled={true}
        htmFlag="5"
      />
      <Typography variant="body2Medium">{t('detail.type5.radioLabel1')}</Typography>
      <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
        <Radio
          label={tCommon('radioGroup.yes')}
          size="medium"
          checked={dataList.htm062 == '1'}
          value="1"
          onChange={() => {}}
        />
        <Radio
          label={tCommon('radioGroup.no')}
          size="medium"
          checked={dataList.htm062 != '1'}
          value=""
          onChange={() => {}}
        />
      </div>
      <Typography variant="body2Medium">{t('detail.type5.radioLabel2')}</Typography>
      <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
        <Radio
          label={tCommon('radioGroup.yes')}
          size="medium"
          checked={dataList.htmTaxFlag == '1'}
          value="1"
          onChange={() => {}}
        />
        <Radio
          label={tCommon('radioGroup.no')}
          size="medium"
          checked={dataList.htmTaxFlag != '1'}
          value=""
          onChange={() => {}}
        />
      </div>
      <TextField
        size="small"
        label={t('detail.type5.inputLabel4')}
        value={dataList.htm143 || ''}
        onChange={() => {}}
        disabled={true}
      />
    </div>
  );
};

export default Type5;
